import adaEmbed from '@ada-support/embed2';
import { getChatbotData } from 'src/api/enrollments';

export function useChatbot() {
  const start = async (enrollmentId: string) => {
    const result = await getChatbotData(enrollmentId);

    const metadata: Record<string, string> = {};
    Object.entries(result.data).forEach(([key, value]) => {
      metadata[key] = `${value}`;
    });

    await adaEmbed.start({
      handle: 'pennfostergroup',
      lazy: true,
      metaFields: metadata,
    });
  };

  const stop = () => {
    adaEmbed.stop();
  };

  const toggle = () => {
    adaEmbed.toggle();
  };

  return {
    stop,
    start,
    toggle,
  };
}
